var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76739 7.00431H14.8254M5.76739 9.95036H14.8254M5.76739 13.3758H10.8208M1 1.91764C1 1.41738 1.40554 1.01184 1.9058 1.01184H18.2101C18.7104 1.01184 19.1159 1.41738 19.1159 1.91764V19.1278C19.1159 19.628 18.7104 20.0336 18.2101 20.0336H1.9058C1.40554 20.0336 1 19.628 1 19.1278V1.91764Z",
    stroke: "current",
    strokeWidth: 0.905797
  })));
};
export default __webpack_public_path__ + "static/media/dating_report.9556819e.svg";
export { SvgComponent as ReactComponent };